import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetShipmentListMutation } from '../../../../store/api/shipmentApi';
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";

import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";

const Lpntable = () => {
    const navigate = useNavigate();
	const { screenHeight, screenScaling,pageSize} = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [shipmentData, setShipmentData] = useState({ shipment_data: [], total_no_of_records: 0 });
    const [getShipmentList] = useGetShipmentListMutation();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();


    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '5%', type: 'number' },
        { name: 'name', label: 'Shipment No', width: '12%', type: 'text' },
        { name: 'pickup_company', label: 'Pickup Company', width: '15%', type: 'text' },
        { name: 'custom_logistics_provider', label: 'Logistics Provider', width: '15%', type: 'text' },
        {
            name: 'status',
            label: 'Status',
            width: '12%',
            type: 'select',
            options: [
                { value: 'Draft', label: 'Draft' },
                { value: 'Submitted', label: 'Submitted' },
            ]
        },
        { name: 'custom_posting_date', label: 'Posting Date', type: 'date', width: '15%' },
        { name: 'pickup_date', label: 'Pickup Date', type: 'date', width: '15%' },
    ];

    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '7%',
            cellRenderer: (row) => row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Shipment ID",
            name: "Shipment No",
            accessor: "name",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Pickup Company",
            name: "Pickup Company",
            accessor: "pickup_company",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Logistics Provider",
            name: "Logistics Provider",
            accessor: "custom_logistics_provider",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            width: '10%',
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                let textColor;
                let bgColor;

                switch (row.status) {
                    case 'Submitted':
                        textColor = '#16A34A';
                        bgColor = 'rgba(22, 163, 74, 0.1)';
                        break;
                    case 'Cancelled':
                        textColor = '#FF0B03';
                        bgColor = 'rgba(255, 11, 3, 0.1)';
                        break;
                    case 'Draft':
                        textColor = '#FFAA0B';
                        bgColor = 'rgba(255, 170, 11, 0.1)';
                        break;
                    default:
                        textColor = '#000000';
                        bgColor = 'rgba(0, 0, 0, 0.05)';
                }

                return (
                    <span style={{
                        backgroundColor: bgColor,
                        color: textColor,
                        padding: '4px 10px',
                        borderRadius: '9999px',
                        fontSize: '12px',
                        fontWeight: 500,
                        display: 'inline-block',
                        textTransform: 'capitalize',
                    }}>
                        {row.status}
                    </span>
                );
            }
        },
        {
            header: "Posting Date",
            name: "Posting Date",
            accessor: "custom_posting_date",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Pickup Date",
            name: "Pickup Date",
            accessor: "pickup_date",
            width: '15%',
            sortable: true,
            visible: true
        },
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            accessor: 'action',
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                    actions={['view', 'edit', 'delete']}
                />
            )
        }
    ]);

    const handleSaveColumns = (selectedKeys) => {
        const updatedColumns = columnsConfig.map(column => ({
            ...column,
            visible: selectedKeys.includes(column.accessor)
        }));
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible), [columnsConfig]);

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            })), [columnsConfig]);

    const handleView = (id) => navigate(`/outbound/shippinglist-view/`, { state: { shipment_id: id } });
    const handleEdit = (id) => navigate(`/outbound/shippinglist-edit/`, { state: { shipment_id: id } });
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Shipment?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Shipment", name: delSelectedId }).unwrap()
            setDelmessage(`Shipment ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                getData();
                setDelSelectedId(null);
            }, 1000);
            
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Shipment!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
       className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/outbound/shippinglist-create",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Shipment"
        }
    ];

    const getData = async () => {
			setLoading(true);
			try {
				const filteredSearchInput = Object.entries(filters).reduce(
					(acc, [key, value]) => {
						if (value !== "" && value !== undefined && value !== null) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);
				const siNoFilter = filteredSearchInput.siNo;
				const isSiNoFilterActive =
					siNoFilter !== undefined && siNoFilter !== "";
				// STEP 3: If filtering by siNo, jump to that page
				const targetPage = isSiNoFilterActive
					? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
					: currentPage;
				const payload = {
					start: pageSize * (targetPage - 1),
					page_length: pageSize,
					...(Object.keys(filteredSearchInput).length > 0 && {
						search_input: {
							name: filteredSearchInput.name || "",
							pickup_company: filteredSearchInput.pickup_company || "",
							custom_logistics_provider:
								filteredSearchInput.custom_logistics_provider || "",
							status: filteredSearchInput.status || "",
							custom_posting_date:
								filteredSearchInput.custom_posting_date || "",
							pickup_date: filteredSearchInput.pickup_date || "",
						},
					}),
				};

				const response = await getShipmentList(payload);
				const rawData = response.data.data.shipment_data;
				// STEP 4: Assign global serial numbers
				const numberedData = rawData.map((item, index) => ({
					...item,
					siNo: index + 1 + pageSize * (targetPage - 1),
				}));

				// STEP 5: If siNo is used, filter client-side
				const finalData = isSiNoFilterActive
					? numberedData.filter(
						(item) => item.siNo === parseInt(siNoFilter, 10)
					)
					: numberedData;
				setShipmentData({
					shipment_data: finalData,
					total_no_of_records: response.data.data.total_shipment_count,
				});
				if (isSiNoFilterActive) setCurrentPage(targetPage);
			} catch (error) {
				console.error("Error fetching shipments:", error);
			} finally {
				setLoading(false);
			}
		};

    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
        if (pageSize > 0) {
            getData();
        }
	}, [currentPage, filters, pageSize, screenHeight, screenScaling]);
    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Outbound" },
                    { label: "Shipment", style: { color: '#270B79' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Shipment"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "name", "status", "action"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={shipmentData.shipment_data}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={shipmentData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Shipment"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Lpntable;